import { ImageStoreDTO } from 'business/models/Models';
import React from 'react';
import { storageHeaderColumns } from '../utils';
import { FmlxButton, FmlxTable } from 'fmlx-common-ui';
import { ContentCopyIcon } from '@fmlx/icons';

interface Props {
  imageStoreList: ImageStoreDTO[];
  tableClass?: string;
  headerColumns?: any;
  rowsData?: any;
  selectedIds?: number[];
  enableMultiSelection?: boolean;
  onCheckboxSelectionChange?: (rowIndices: number[]) => void;
  mainContainerStyle?: React.CSSProperties;
}

const ImageStoreInfoModal = (props: Props) => {
  const {
    imageStoreList,
    headerColumns,
    rowsData,
    selectedIds,
    enableMultiSelection,
    onCheckboxSelectionChange,
  } = props;

  const storageData = imageStoreList.map((store) => ({
    name: store.name,
    directory: (
      <div className="flex justify-between items-center w-full">
        <span>{store.basePath}</span>
        <FmlxButton
          id="copy-icon"
          onlyIcon={true}
          size={FmlxButton.Size.SMALL}
          type={FmlxButton.Type.BASIC}
          variant={FmlxButton.Variant.PLAIN}
          icon={<ContentCopyIcon size="xs" />}
          tooltipDescription="Copy"
          onClick={() => {
            navigator.clipboard.writeText(store.basePath);
          }}
        />
      </div>
    ),
    space: store.availableSize,
  }));

  return (
    <div id="imagestoreinfomodal-wrapper" className="flex flex-column w-full">
      <FmlxTable
        id="fmlx-table-storageInfo"
        columns={headerColumns ? headerColumns : storageHeaderColumns}
        data={rowsData ? rowsData : storageData}
        {...(enableMultiSelection && {
          type: FmlxTable.Type.MULTISELECT,
          selectedRowIds: selectedIds,
          showToolbar: false,
          getSelectedRow: (_, rowIds: string[]) =>
            onCheckboxSelectionChange?.(rowIds.map((rowId) => Number(rowId))),
        })}
      />
    </div>
  );
};

export default ImageStoreInfoModal;
